import { render, staticRenderFns } from "./userStamps.vue?vue&type=template&id=29976fbb"
import script from "./userStamps.vue?vue&type=script&lang=js"
export * from "./userStamps.vue?vue&type=script&lang=js"
import style0 from "./userStamps.vue?vue&type=style&index=0&id=29976fbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports